import { jsx as _jsx } from "react/jsx-runtime";
import { Primary100Shadow } from "../fundations/effects/focusRing";
import { getBorderToken, getToggleToken, getButtonToken, getFieldToken } from "../fundations/palette/colorTokens";
import { Corner4 } from "../fundations/shape/corners";
const CheckedSVG = ()=>/*#__PURE__*/ _jsx("span", {
        style: {
            width: 16,
            height: 16,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ _jsx("svg", {
            width: "10",
            height: "10",
            viewBox: "0 0 10 8",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.47022 0.529735C9.72992 0.789434 9.72992 1.21049 9.47022 1.47019L3.97022 6.97019C3.71052 7.22989 3.28946 7.22989 3.02977 6.97019L0.529765 4.47019C0.270067 4.21049 0.270067 3.78943 0.529765 3.52973C0.789464 3.27004 1.21052 3.27004 1.47022 3.52973L3.49999 5.55951L8.52977 0.529735C8.78946 0.270036 9.21052 0.270036 9.47022 0.529735Z",
                fill: "white"
            })
        })
    });
const IndeterminateIcon = ()=>/*#__PURE__*/ _jsx("span", {
        style: {
            width: 16,
            height: 16,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ _jsx("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.83502 6.00002C1.83502 5.63275 2.13275 5.33502 2.50002 5.33502H9.50002C9.86729 5.33502 10.165 5.63275 10.165 6.00002C10.165 6.36729 9.86729 6.66502 9.50002 6.66502H2.50002C2.13275 6.66502 1.83502 6.36729 1.83502 6.00002Z",
                fill: "white"
            })
        })
    });
export const Checkbox = {
    MuiCheckbox: {
        defaultProps: {
            size: "small",
            disableRipple: true,
            icon: /*#__PURE__*/ _jsx("span", {
                style: {
                    width: 16,
                    height: 16
                }
            }),
            checkedIcon: /*#__PURE__*/ _jsx(CheckedSVG, {}),
            indeterminateIcon: /*#__PURE__*/ _jsx(IndeterminateIcon, {})
        },
        styleOverrides: {
            root: ({ theme })=>({
                    padding: 0,
                    border: `1px solid ${getBorderToken("border300", theme)}`,
                    borderRadius: Corner4,
                    backgroundColor: getFieldToken("field01", theme),
                    "&.Mui-focusVisible": {
                        boxShadow: Primary100Shadow
                    },
                    "&:hover": {
                        backgroundColor: getButtonToken("buttonSecondaryHover", theme)
                    },
                    "&.MuiCheckbox-indeterminate": {
                        backgroundColor: getToggleToken("toggleSelected", theme),
                        borderColor: getToggleToken("toggleSelected", theme),
                        "&:hover": {
                            backgroundColor: getToggleToken("toggleSelectedHover", theme),
                            borderColor: getToggleToken("toggleSelectedHover", theme)
                        },
                        "&.Mui-disabled": {
                            backgroundColor: getToggleToken("toggleDisabled", theme),
                            borderColor: getToggleToken("toggleDisabled", theme)
                        }
                    },
                    "&.Mui-checked": {
                        backgroundColor: getToggleToken("toggleSelected", theme),
                        borderColor: getToggleToken("toggleSelected", theme),
                        "&:hover": {
                            backgroundColor: getToggleToken("toggleSelectedHover", theme),
                            borderColor: getToggleToken("toggleSelectedHover", theme)
                        }
                    },
                    "&.Mui-disabled": {
                        borderColor: getBorderToken("borderDisabled", theme),
                        "&.Mui-checked": {
                            backgroundColor: getToggleToken("toggleDisabled", theme),
                            borderColor: getToggleToken("toggleDisabled", theme)
                        }
                    }
                })
        },
        variants: [
            {
                props: {
                    size: "medium"
                },
                style: ()=>({
                        width: 20,
                        height: 20
                    })
            },
            {
                props: {
                    size: "small"
                },
                style: ()=>({
                        width: 16,
                        height: 16
                    })
            }
        ]
    }
};

//# sourceMappingURL=Checkbox.js.map